export const siteConfig = {
  name: "Diti Giri",
  role: "Founding Engineer @ CyberDesk GmbH",
  tagline: "Software Engineer building security products at CyberDesk GmbH. Automation enthusiast. Motorcycles DIYer in my free time.",
  intro: "Usually found building tools, writing about systems, or working on my motorcycles.",
  summary:
    "I focus on cloud infrastructure, cybersecurity, and product engineering. I enjoy shipping small tools, writing about systems work, and helping teams move faster with clean, reliable software.",
  location: "India",
  email: "ditikrushna.nit@gmail.com",
  resumeUrl: "https://drive.google.com/file/d/REPLACE_ME/view",
  social: {
    github: "https://github.com/ditikrushna",
    linkedin: "https://linkedin.com/in/ditikrushnagiri",
  },
};

export const navLinks = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/projects", label: "Projects" },
  { path: "/blog", label: "Blog" },
  { path: "/uses", label: "Uses" },
  { path: "/opensource", label: "Open Source" },
];
